/* Pawori - legt het cadeau vanzelf in de winkelwagen.
   Powerbank 10.000 mAh: een per kledingstuk.
   De korting zelf regelt Shopify; deze code zorgt alleen dat de regel erin ligt.

   Koos de klant op de productpagina voor de upgrade, dan staat dat als eigenschap
   "Powerbank" op de kledingregel. Deze code legt dan de 20.000 van 15 euro in de
   mand in plaats van de gratis 10.000. Een gemengde winkelwagen kan dus allebei
   bevatten, en de aantallen kloppen per kledingstuk.

   De cadeaubon van 10 euro zit hier NIET in. Shopify staat geen korting toe op
   cadeaubonproducten - een bon in de mand blijft dus gewoon 10 euro kosten.
   Getest op 26-09-2026: powerbank 2995 -> 0, cadeaubon 1000 -> 1000.
   Die bon moet op een andere manier bij de klant komen. */
(function () {
  'use strict';

  var POWERBANK = 56305926668673;   /* Powerbank 10.000 mAh, gratis bij kleding */
  var UPGRADE   = 56336027058561;   /* Powerbank 20.000 mAh (upgrade), 15 euro */
  var UPGRADE_KEUZE = '20.000 mAh (upgrade)';
  var KLEDING = ['jas', 'bodywarmer', 'hoodie', 'broek', 'thermovest', 'thermoset'];
  var MERK = '_cadeau';
  var MERKWAARDE = 'ja';

  var origFetch = window.fetch.bind(window);
  var bezig = false;

  function isKleding(item) {
    var t = (item.product_type || '').toLowerCase().trim();
    return KLEDING.indexOf(t) !== -1;
  }

  function isCadeauregel(item, variant) {
    if (item.variant_id !== variant && item.id !== variant) return false;
    var p = item.properties || {};
    return p[MERK] === MERKWAARDE;
  }

  function haalWinkelwagen() {
    return origFetch(wortel() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function wortel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function post(pad, body) {
    return origFetch(wortel() + pad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Brengt de cadeauregels in lijn met wat er in de mand ligt.
     Geeft true terug als er iets is veranderd. */
  function stemAf() {
    if (bezig) return Promise.resolve(false);
    bezig = true;

    return haalWinkelwagen().then(function (cart) {
      var items = cart.items || [];
      var standaard = 0;
      var upgrades = 0;
      items.forEach(function (i) {
        if (!isKleding(i)) return;
        var keuze = (i.properties || {})['Powerbank'] || '';
        if (keuze === UPGRADE_KEUZE) { upgrades += i.quantity; } else { standaard += i.quantity; }
      });

      var gewenst = {};
      gewenst[POWERBANK] = standaard;
      gewenst[UPGRADE] = upgrades;

      var stappen = [];
      Object.keys(gewenst).forEach(function (sleutel) {
        var variant = Number(sleutel);
        var wil = gewenst[variant];
        var regel = null;
        var regelnr = 0;

        for (var n = 0; n < items.length; n++) {
          if (isCadeauregel(items[n], variant)) { regel = items[n]; regelnr = n + 1; break; }
        }

        if (!regel && wil > 0) {
          var props = {};
          props[MERK] = MERKWAARDE;
          stappen.push({ soort: 'toevoegen', variant: variant, aantal: wil, props: props });
        } else if (regel && regel.quantity !== wil) {
          stappen.push({ soort: 'wijzigen', regel: regelnr, aantal: wil });
        }
      });

      if (!stappen.length) { bezig = false; return false; }

      /* Een voor een, want elke wijziging hernummert de regels. */
      var keten = Promise.resolve();
      stappen.forEach(function (stap) {
        keten = keten.then(function () {
          if (stap.soort === 'toevoegen') {
            return post('cart/add.js', {
              items: [{ id: stap.variant, quantity: stap.aantal, properties: stap.props }]
            });
          }
          return post('cart/change.js', { line: stap.regel, quantity: stap.aantal });
        }).catch(function (e) { console.warn('[Pawori cadeaus]', e); });
      });

      return keten.then(function () { bezig = false; return true; });
    }).catch(function (e) {
      bezig = false;
      console.warn('[Pawori cadeaus]', e);
      return false;
    });
  }

  /* Vangt elke wijziging van de winkelwagen af en stemt daarna de cadeaus af,
     voordat het thema zijn eigen verversing doet. */
  var RAAKT_MAND = /\/cart\/(add|change|update|clear)(\.js)?$/;

  /* De productpagina onderschept het formulier en bouwt zelf een JSON-verzoek.
     Daardoor gaat de eigenschap "Powerbank" uit het verborgen veld verloren.
     Hieronder hangen we hem alsnog aan de regel van het gekozen kledingstuk. */
  function plakKeuzeErbij(url, init) {
    if (bezig) return init;
    if (!/\/cart\/add(\.js)?$/.test((url.split('?')[0] || ''))) return init;
    if (!init || typeof init.body !== 'string') return init;

    var veld = document.querySelector('[data-tvpb-prop]');
    if (!veld || !veld.value) return init;

    var form = veld.closest('form');
    var idVeld = form ? form.querySelector('[name="id"]') : null;
    var gekozenId = idVeld ? Number(idVeld.value) : null;
    if (!gekozenId) return init;

    var payload;
    try { payload = JSON.parse(init.body); } catch (e) { return init; }
    if (!payload || !payload.items || !payload.items.length) return init;

    payload.items.forEach(function (regel) {
      if (Number(regel.id) !== gekozenId) return;
      regel.properties = regel.properties || {};
      if (!regel.properties['Powerbank']) regel.properties['Powerbank'] = veld.value;
    });

    var kopie = {};
    Object.keys(init).forEach(function (k) { kopie[k] = init[k]; });
    kopie.body = JSON.stringify(payload);
    return kopie;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    init = plakKeuzeErbij(url, init);
    var raakt = !bezig && RAAKT_MAND.test((url.split('?')[0] || ''));
    var resultaat = origFetch(input, init);
    if (!raakt) return resultaat;

    return resultaat.then(function (respons) {
      if (!respons.ok) return respons;
      return stemAf().then(function () { return respons; });
    });
  };

  function bijStart() {
    stemAf().then(function (veranderd) {
      if (!veranderd) return;
      var opMandpagina = /\/cart(\/|$)/.test(window.location.pathname);
      if (opMandpagina && !sessionStorage.getItem('termvo-cadeaus-herladen')) {
        sessionStorage.setItem('termvo-cadeaus-herladen', '1');
        window.location.reload();
      }
    });
    setTimeout(function () { sessionStorage.removeItem('termvo-cadeaus-herladen'); }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bijStart);
  } else {
    bijStart();
  }
})();
